import React from 'react';

import Icon1 from '../../images/svg-camping.svg';
import Icon2 from '../../images/svg-burger.svg';
import Icon3 from '../../images/svg-fire.svg';
import { ServicesContainer, ServicesCard, ServicesWrapper, ServicesH1, ServicesH2, ServicesIcon, ServicesP } from './ServicesElements';

const Services = () => {
    return (
        <>
            <ServicesContainer id="projects">
                <ServicesH1>My Projects</ServicesH1>
                <ServicesWrapper>
                    <ServicesCard href="https://polar-waters-83346.herokuapp.com/" target="_blank">
                        <ServicesIcon src={Icon1} />
                        <ServicesH2>YelpCamp</ServicesH2>
                        <ServicesP>
                            The purpose of the project was to create a review website for camping grounds around the world, just like we have for restaurants and hotels.
                        </ServicesP>
                    </ServicesCard>
                    <ServicesCard href="https://react-my-burger-e5fe1.web.app/" target="_blank">
                        <ServicesIcon src={Icon2} />
                        <ServicesH2>BurgerBuilder</ServicesH2>
                        <ServicesP>
                            The purpose of the project was to build single-page burger shopping website, where people can build their own burgers and place orders using the Checkout button.
                        </ServicesP>
                    </ServicesCard>
                    <ServicesCard href="https://ishtakkar.github.io/wildfire-tracker/" target="_blank">
                        <ServicesIcon src={Icon3} />
                        <ServicesH2>Wildfire Tracker</ServicesH2>
                        <ServicesP>
                            A React Web Application created to track real-time wildfires around the globe using NASA's Open API.
                        </ServicesP>
                    </ServicesCard>
                </ServicesWrapper>
            </ServicesContainer>
        </>
    );
};

export default Services;